import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-itmgmt-dark-blue text-white pt-12 pb-8">
      <div className="container-wide">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-4">IT Management Solutions</h3>
            <p className="text-gray-300 mb-4">
              Comprehensive IT support for small to mid-sized businesses. Eliminating IT headaches so you can focus on growth.
            </p>
            <p className="text-gray-300">
              Location: Airmont, NY and surrounding areas
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/services/managed-it" 
                  className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors"
                  aria-label="Learn about our Managed IT Services solutions"
                  title="Comprehensive Managed IT Services for businesses"
                >
                  Explore Managed IT Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/cybersecurity" 
                  className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors"
                  aria-label="Learn about our Cybersecurity solutions" 
                  title="Protect your business with our Cybersecurity solutions"
                >
                  Cybersecurity Protection
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/network-infrastructure" 
                  className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors"
                  aria-label="Learn about our Network & Infrastructure solutions"
                  title="Network & Infrastructure solutions for your business"
                >
                  Network & Infrastructure Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/cloud-solutions" 
                  className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors"
                  aria-label="Learn about our Cloud Solutions"
                  title="Cloud Solutions to enhance your business operations"
                >
                  Cloud Solutions & Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/project-consulting" 
                  className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors"
                  aria-label="Learn about our IT Strategy & Project Consulting"
                  title="Strategic IT consulting to align technology with your business goals"
                >
                  IT Strategy & Consulting
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/specialty-services" 
                  className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors"
                  aria-label="Learn about our Specialty IT Services"
                  title="Specialized IT services tailored to your unique requirements"
                >
                  Specialty IT Services
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Industries</h3>
            <ul className="space-y-2">
              <li>
                <a href="#industries" className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors">
                  CPA Firms
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors">
                  Real Estate Agencies
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors">
                  Property Managers
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors">
                  Healthcare Offices
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-300 hover:text-itmgmt-bright-blue transition-colors">
                  Small Businesses
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <span className="block">Phone:</span>
                <a href="tel:+18777486468" className="hover:text-itmgmt-bright-blue transition-colors">
                  +1-877-748-6468
                </a>
              </li>
              <li className="text-gray-300">
                <span className="block">Email:</span>
                <a href="mailto:info@itmgmtsol.com" className="hover:text-itmgmt-bright-blue transition-colors">
                  info@itmgmtsol.com
                </a>
              </li>
              <li className="text-gray-300">
                <span className="block">Domain:</span>
                <a href="https://itmgmtsol.com" className="hover:text-itmgmt-bright-blue transition-colors">
                  itmgmtsol.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {currentYear} IT Management Solutions. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
